import { useState, useEffect, useMemo } from "react";
import "./Visualizador.css";
import WalletConnect from "./services/WalletConnect";
import useWalletConnect from "./hooks/useWalletConnect";
import Calculo from "./calculos/Calculo";
import useBitcoinAddressValidation from "./hooks/useBtcinput";
import useConfirmTransaction from "./hooks/useConfirmTransaction";
import useEnviarConfirmacionServidor from "./hooks/useEnviarConfirmacionServidor";
import BuyProgressModal from "./BuyProgressModal";
import NetworkSwitcher from "./NetworkSwitcher"; // Importa el nuevo componente
import { networks } from "../networks";
import { getTasaDeCambio } from "../utils/exchangeRate";
import useContractAddress from "./hooks/useContractAddress";

function Visualizador() {
  const { address, network, provider, connectWallet, onDisconnect } = useWalletConnect();
  const [cantidadEth, setCantidadEth] = useState("");
  const [error, setError] = useState("");



  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace(',', '.');
    if (inputValue === "") {
      setCantidadEth("");
      setError("");
      return;
    }

    const value = parseFloat(inputValue);
    if (isNaN(value)) {
      setCantidadEth("");
      return;
    }

    const tasaDeCambio = getTasaDeCambio(network, selectedTokenSymbol);
    const MAX_TBTC = parseFloat(process.env.REACT_APP_MAX_TBTC) || 30;
    const maxInput = MAX_TBTC / tasaDeCambio;

    if (value > maxInput) {
      setError(`MAX Amount ${maxInput.toFixed(5)} `);
      return;
    }
    setError("");
    setCantidadEth(value);
  };

  
  const { bitcoinAddress, isValid, handleBitcoinAddressChange } = useBitcoinAddressValidation();
  const contractAddress = useContractAddress(network);
  const { confirmTransaction } = useConfirmTransaction(provider, address, contractAddress);

  const [bloquesConfirmados, setBloquesConfirmados] = useState(0);
  const [transferenciaEnviada, setTransferenciaEnviada] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [selectedTokenSymbol, setSelectedTokenSymbol] = useState("");

  useEffect(() => {
    if (!network) {
      // Si no hay red conectada, establece un valor por defecto (ej. mainnet)
      setSelectedNetwork("mainnet");
    }
  }, [network]);

  useEffect(() => {
    if (network) {
      const networkKey = Object.keys(networks).find(key => parseInt(networks[key].chainId, 16) === Number(network.chainId));
      if (networkKey) {
        setSelectedNetwork(networkKey);
        // Set selectedTokenSymbol to the native currency of the new network
        setSelectedTokenSymbol(networks[networkKey].nativeCurrency.symbol);
      }
    }
  }, [network]);

  useEffect(() => {
    if (selectedNetwork) {
      // Ensure selectedTokenSymbol is valid for the new selectedNetwork
      const networkData = networks[selectedNetwork];
      const currentTokenExists = networkData.tokens?.some(t => t.symbol === selectedTokenSymbol) || networkData.nativeCurrency.symbol === selectedTokenSymbol;
      if (!currentTokenExists) {
        setSelectedTokenSymbol(networkData.nativeCurrency.symbol);
      }
    }
  }, [selectedNetwork, selectedTokenSymbol]);

  const {
    enviarConfirmacionServidor,
    estado,
    loading,
    txid,
  } = useEnviarConfirmacionServidor({
    cantidadTbtc: cantidadEth,
    direccionBitcoin: bitcoinAddress,
    address: address,
    selectedTokenSymbol: selectedTokenSymbol,
  });

  const handleConfirmar = async () => {
    setTransferenciaEnviada(false);
    setBloquesConfirmados(0);
    const selectedToken = (selectedNetwork && networks[selectedNetwork].tokens && networks[selectedNetwork].tokens.find(t => t.symbol === selectedTokenSymbol)) || networks[selectedNetwork].nativeCurrency;
    await confirmTransaction(
      cantidadEth,
      isValid,
      bitcoinAddress,
      enviarConfirmacionServidor,
      (bloque) => setBloquesConfirmados(bloque),
      () => {
        setTransferenciaEnviada(true);
        setIsModalOpen(true);
      },
      selectedToken.address,
      selectedToken.decimals
    );
  };

  const closeModal = () => {
    setIsModalOpen(false);
    window.location.reload();
  };

  const networkName = selectedNetwork ? networks[selectedNetwork].chainName : 'Unsupported Network';
  const selectedToken = useMemo(() => {
    if (!selectedNetwork) return null;
    const networkData = networks[selectedNetwork];
    if (!networkData) return null;
    return networkData.tokens?.find(t => t.symbol === selectedTokenSymbol) || networkData.nativeCurrency;
  }, [selectedNetwork, selectedTokenSymbol]);
  const currencySymbol = selectedToken ? selectedToken.symbol : 'ETH';
  const currencyLogo = selectedToken ? selectedToken.logo : "/images/logoeth2.webp";

  const pasos = [
    {
      label: `${networkName} Deposit`,
      completado: transferenciaEnviada,
    },
    {
      label: `confirmations `,
      completado: bloquesConfirmados === 1,
    },
    {
      label: "tbtc deposit",
      completado: estado && estado.toLowerCase().includes("éxito"),
    },
  ];

  const mensajesPasos = [
    "¡Deposit dedected! waiting for confirmations...",
    " Deposit confirmed! sending TBTC to user...",
    "¡TBTC deposited to user succsseful!",
  ];

  const availableTokens = selectedNetwork ? [networks[selectedNetwork].nativeCurrency, ...(networks[selectedNetwork].tokens || [])] : [];

  return (
    <>
      <div className="header-div"></div>
      <div className="principal">
        <div className="swap-container">
          <div className="swap-header">
            <div className="swap-settings" style={{ display: 'flex', alignItems: 'center' }}>
              <WalletConnect 
                walletAddress={address}
                onConnect={() => connectWallet(selectedNetwork)}
                onDisconnect={onDisconnect}
                network={network}
              />
              {!address && <NetworkSwitcher 
                selectedNetwork={selectedNetwork}
                setSelectedNetwork={setSelectedNetwork}
                isDisabled={!!address}
              />}
            </div>
          </div>

          <div className="swap-row">
            <div className="card swap-section swap-half">
              <div className="swap-label">Deposit</div>
              <div className="swap-input-row">
                <input
                  type="number"
                  step="any"
                  inputMode="decimal"
                  className={`swap-amount-input ${error ? "invalid-input" : ""}`}
                  placeholder="0"
                  value={cantidadEth}
                  onChange={handleInputChange}
                />
                <div className="swap-currency">
                  <img
                    src={currencyLogo}
                    alt={currencySymbol}
                    width="40"
                    height="40"
                  />
                  <div>
                    <select className="token-select" onChange={(e) => setSelectedTokenSymbol(e.target.value)} value={selectedTokenSymbol}>
                      {availableTokens.map(token => (
                        <option key={token.symbol} value={token.symbol}>
                          {token.symbol}
                        </option>
                      ))}
                    </select>
                    <div className="swap-currency-network">on {networkName}</div>
                  </div>
                </div>
              </div>
              {error && <div className="error-message">{error}</div>}
            </div>

            <div className="card swap-section swap-half">
              <div className="swap-label">Receive</div>
              <div className="swap-input-row">
                <div className="swap-amount">
                  <Calculo cantidadEth={cantidadEth} network={network} selectedTokenSymbol={selectedTokenSymbol} />
                </div>
                <div className="swap-currency">
                  <img
                    src="/images/logobtc.png"
                    alt="BTC"
                    width="50"
                    height="50"
                  />
                  <div>
                    <div className="swap-currency-text">TBTC</div>
                    <div className="swap-currency-network">on Tbtc3</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="swap-row">
            <div className="card swap-section swap-half">
              <div className="swap-label">Destination TBTC3 Address</div>
              <div className="swap-input-row">
                <input
                  type="text"
                  className={`swap-address ${!isValid && bitcoinAddress ? "invalid-address" : ""}`}
                  placeholder="Enter Bitcoin Testnet address"
                  value={bitcoinAddress}
                  onChange={handleBitcoinAddressChange}
                />
              </div>
              {!isValid && bitcoinAddress && (
                <div className="error-message">Invalid address, use legacy or nested-segwit </div>
              )}
            </div>

            <div className="card swap-section swap-half">
              <div className="swap-label">Refund Address</div>
              <div className="swap-address" >  {address || "Wallet Address"}</div>
            </div>
          </div>

          <button
            onClick={handleConfirmar}
            className="swap-button main-action"
            disabled={loading || pasos[0].completado}
          >
            {loading
              ? "Processing..."
              : pasos[0].completado
              ? "Transaction sent"
              : "Confirm"}
          </button>

          <BuyProgressModal
            isOpen={isModalOpen}
            steps={pasos}
            mensajesPasos={mensajesPasos}
            txid={txid}
            onClose={closeModal}
          />
        </div>
        
      </div>
    </>
  );
}

export default Visualizador;